import Vue from 'vue'
import App from './App.vue'

import VueMaterial from 'vue-material'  // UI component library
import Axios from 'axios'               // AJAX library
import VueAxios from 'vue-axios'        // Vue wrapper for Axios

import 'vue-material/dist/vue-material.min.css'

Vue.config.productionTip = false

Vue.use(VueMaterial, Axios, VueAxios)

new Vue({
  render: h => h(App),
}).$mount('#app')